<template>
<v-app id="inspire">
  <v-content class="teal darken-3">
    <div style="text-align: -webkit-center" class="teal darken-3">
        <v-card class="mt-2" width="50%">
            <v-card-title class="teal darken-4 white--text">Form Registrasi Customer</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form @submit="validate" ref="form" v-model="valid" lazy-validation>
                  <v-text-field v-model="inputDataCustomer.name" :rules="[ v => !!v || 'Required.']" label="Name"></v-text-field>
                  <v-text-field v-model="inputDataCustomer.username" :rules="[ v => !!v || 'Required.']" label="Username"></v-text-field>
                  <v-autocomplete
                    v-model="inputDataCustomer.role_id"
                    :items="roles"
                    :rules="[ v => !!v || 'Required.']"
                    item-text='name'
                    item-value='id'
                    label="Tipe User"
                  ></v-autocomplete>
                  <v-text-field 
                    v-model="inputDataCustomer.email"
                    :rules="[ v => !!v || 'Required.']"
                    label="Email">
                  </v-text-field>
                  <v-text-field type="number" v-model="inputDataCustomer.telp" label="Telp" :rules="[ v => !!v || 'Required.']"></v-text-field>
                  <v-text-field type="password" v-model="inputDataCustomer.password" label="Password" :rules="[ v => !!v || 'Required.']"></v-text-field>
                  <v-text-field type="password" v-model="inputDataCustomer.password_conf" label="Confirmation" :rules="[ v => !!v || 'Required.']"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn 
                  class="teal darken-4 white--text"
                  :disabled="!valid"
                  medium
                  @click="validate"
              >
                  Daftar
              </v-btn>
          </v-card-actions>
        </v-card>
    </div>
  </v-content>
  <v-snackbar style="z-index: 9999"
    :top='true'
    v-model='snackbar.visible'
    :color='snackbar.color'
    :timeout='snackbar.timeout'
    :multi-line='snackbar.multiline'
  >{{snackbar.text}}</v-snackbar>
</v-app>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find } from "lodash";
import moment from 'moment';
export default {
  name: "Registrasi",
  components: {
  },
  data() {
    return {
      valid: true,
      inputDataCustomer: {},
      overlay: false,
      roles: [],
      company: {}
    };
  },
  computed: {
      ...mapGetters({
          getRoles: "user/getRoles"
      }),
      ...mapState({
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      // showLoading: "showLoading",
      closeLoading: "closeLoading",
    }),
    ...mapActions({
      createUser: "user/createUser",
    }),
    async initialize(){
      const getRoles = await this.getRoles
      for(let role of getRoles.data.attributes){
          this.roles.push({
              name: role.name == 'unverified' ? 'Personal' : 'Company',
              id: role.id
          })
      }
      this.company = JSON.parse(window.localStorage.getItem('company'))
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if(this.inputDataCustomer.password==this.inputDataCustomer.password_conf){
          try {
              this.overlay = true
              let response = await this.createUser(this.inputDataCustomer)
              // console.log('response', response)
              if (!response.data.success) {
                  this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
              } else {
                  this.showSnackbar({ text: 'Registrasi berhasil...', color: 'green', timeout: 1500 })
                  this.inputDataCustomer = {}
                  this.$refs.form.reset()
                  this.$refs.form.resetValidation()
              }
              this.overlay = false
          } catch (err) {
            console.log(err);
          }
        }else{
          this.showSnackbar({ text: 'Password Confirmation tidak cocok', color: 'red', timeout: 1500 })
        }
      }
    },
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>